import { useSelector, TypedUseSelectorHook } from 'react-redux'
import { VseSessionState } from '../features/session/sessionTypes';
import { default as loginReducer } from '../features/session/sessionSlice';
import { VseSharedDataState } from '../features/sharedData/sharedDataTypes';
import { default as sharedDataReducer } from '../features/sharedData/sharedDataSlice';
import { NewVseApplicationState } from '../features/newAppl/newApplTypes';
import { default as newApplReducer } from '../features/newAppl/newApplSlice';
import { MyApplState } from '../features/myAppl/myApplTypes';
import { default as myApplReducer } from '../features/myAppl/myApplSlice';
import { UserRegisterState } from '../features/account/userRegisterTypes';
import { default as userRegisterReducer } from '../features/account/userRegisterSlice';
import { PasswordResetState } from '../features/password/passwordResetTypes';
import { default as passwordResetReducer } from '../features/password/passwordResetSlice';
import { VseAlertState } from '../features/alert/alertTypes';
import { default as alertReducer } from '../features/alert/alertSlice';

// The top-level state object
export interface ApplicationState {
  alert: VseAlertState,
  session: VseSessionState,
  sharedData: VseSharedDataState,
  newAppl: NewVseApplicationState,
  myAppl: MyApplState,
  userRegister: UserRegisterState,
  passwordReset: PasswordResetState,
}

export const useTypedSelector: TypedUseSelectorHook<ApplicationState> = useSelector;

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  alert: alertReducer,
  session: loginReducer,
  sharedData: sharedDataReducer,
  newAppl: newApplReducer,
  myAppl: myApplReducer,
  userRegister: userRegisterReducer,
  passwordReset: passwordResetReducer,
};

